// src/js/self-service/UpdateExecutingStep.jsx
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CONNECTION_STATE } from './StateConstants.jsx';
import { ScannerFirmwareUpdateFailure } from '../../imports/ec9xns/ec9xns-error.js';

const UpdateExecutingStep = ({
  setState,
  sn,
  updateCandidate,
  doUpdate,               // opcional: MainPage puede inyectarlo
  onBackgroundRefresh     // opcional: para disparar RECONNECTING
}) => {
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const run = async () => {
      try {
        // 1) Dispara el motor real (preferir prop doUpdate si existe)
        if (typeof doUpdate === 'function') {
          await doUpdate((evt) => {
            // hook opcional de progreso; si no lo usas, puedes dejarlo vacío
            // console.debug('[progress]', evt?.currentStepName, evt?.currentStepPercent);
          });
        } else if (updateCandidate && typeof updateCandidate.startUpdate === 'function') {
          await updateCandidate.startUpdate();
        } else {
          throw new Error('No update engine available (updateCandidate/startUpdate).');
        }

        // 2) Éxito -> paso a refresh (reconectar para leer versión nueva)
        setState(CONNECTION_STATE.UPDATE_DONE_REFRESH);
        if (typeof onBackgroundRefresh === 'function') onBackgroundRefresh();
      } catch (e) {
        const msg = e?.message || String(e);
        console.error('[UpdateExecutingStep] update failed:', e);

        // Errores “de motor” (paquete inválido, instalación, etc.) -> UNABLE_UPDATE
        if (e instanceof ScannerFirmwareUpdateFailure) {
          setState(CONNECTION_STATE.UNABLE_UPDATE);
          return;
        }

        // Durante reboot pueden aparecer ERR_NETWORK / timeouts -> tratar como éxito “optimista”
        const isNet =
          (e && (e.code === 'ERR_NETWORK' || /network error/i.test(msg) || /timeout/i.test(msg)));
        if (isNet) {
          setState(CONNECTION_STATE.UPDATE_DONE_REFRESH);
          if (typeof onBackgroundRefresh === 'function') onBackgroundRefresh();
        } else {
          setState(CONNECTION_STATE.UNABLE_UPDATE);
        }
      }
    };

    run();
  }, [setState, doUpdate, updateCandidate, onBackgroundRefresh]);

  return (
    <div>
      Updating the scanner {sn ? `(${sn})` : ''}… Please wait.
    </div>
  );
};

UpdateExecutingStep.propTypes = {
  setState: PropTypes.func.isRequired,
  sn: PropTypes.string,
  updateCandidate: PropTypes.any,
  doUpdate: PropTypes.func,
  onBackgroundRefresh: PropTypes.func
};

export default UpdateExecutingStep;
